<template>
  <div
    class="oct-file-selector"
    :class="[
      `oct-file-selector--${size}`,
      `oct-file-selector--${type}`
    ]"
  >
    <div class="oct-file-selector__content">
      <label class="oct-file-selector__circle" v-if="type !== 'minimal'">
        <oct-add-circle
          class="oct-file-selector__icon"
          :image="image"
          :size="size"
        />

        <!-- @event 'change' -->
        <input
          type="file"
          :multiple="multiple"
          @change="$emit('change', $event.target)"
        >
      </label>

      <label class="oct-file-selector__input">
        <!-- @event 'change' -->
        <input
          type="file"
          :multiple="multiple"
          @change="$emit('change', $event.target)"
        >
        <oct-button
          tagName="span"
          class="oct-file-selector__button"
        >
          Edit

          <!-- Delegate the helper slot to the button component -->
          <template #helper>
            <slot name="helper" />
          </template>
        </oct-button>
      </label>
    </div>
  </div>
</template>

<script>
import OctButton from '@/components/button/OctButton.vue';
import OctAddCircle from '@/components/add-circle/OctAddCircle.vue';

export default {
  components: { OctButton, OctAddCircle },
  name: 'OctFileSelector',
  props: {
    /** Image */
    image: {
      type: Object,
      default () {
        return {
          lowResolution: '',
          standardResolution: ''
        }
      }
    },
    /** Native multiple attirbute */
    multiple: {
      type: Boolean,
      default: false
    },
    /** Size [medium | small] */
    size: {
      type: String,
      default: 'medium'
    },
    /** Type [default | minimal] */
    type: {
      type: String,
      default: 'default'
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-file-selector {
  width: 100%;
}

.oct-file-selector__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .oct-file-selector--small & {
    flex-direction: row;
    align-items: center;
  }
}

.oct-file-selector__circle {
  flex: 0 0 100%;
  width: 100%;
  margin: 0 0 oct-rem(16);
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;

  .oct-file-selector--small & {
    margin: 0 oct-rem(16) 0 0;
  }
}

.oct-file-selector__circle,
.oct-file-selector__input {
  position: relative;
  display: block;

  input[type="file"] {
    display: none;
  }
}
</style>
